import { useAppStateStore } from "@/features/application/state/useAppStateStore"
import { useFavorisApi } from "@/features/services/favoris/FavorisServices"
import { defineStore } from "pinia"
import { ref } from "vue"


type VersionCGU = { num: number }

const PREFERENCES_CGU_VERSION = 'cgu-version' as const
const CGU_CURRENT_VERSION = Object.freeze(parseInt(import.meta.env.VITE_CGU_VERSION ?? '0'))

export const useVersionCGUStore = defineStore('cgu-version', () => {
  const appState = useAppStateStore()
  const numVersion = ref<number>()
  const userKey = ref<string>()

  async function checkCguExpirées() {
    if (!appState.estUtilisateurAuthentifie || appState.estAuthentificationEnCours || appState.estUtilisateurImpersonnalise) {
      if (numVersion.value !== undefined || userKey.value !== undefined) {
        numVersion.value = undefined
        userKey.value = undefined
      }
      return false
    }

    const newKey = appState.utilisateur?.emailAffichage
    if (userKey.value !== newKey) {
      numVersion.value = await loadVersion()
      userKey.value = newKey
    }
    return numVersion.value !== undefined && CGU_CURRENT_VERSION > numVersion.value
  }

  async function setCguValidées() {
    try { await saveCurrentVersion() }
    catch (err) {
      console.error('CGU non sauvegardées', err)
    }
    numVersion.value = CGU_CURRENT_VERSION
  }

  async function saveCurrentVersion() {
    const favManager = useFavorisApi<VersionCGU>(PREFERENCES_CGU_VERSION)
    await favManager.saveFavoris({ num: CGU_CURRENT_VERSION }, { dialogMode: 'silent' })
  }


  async function loadVersion() {
    const favManager = useFavorisApi<VersionCGU>(PREFERENCES_CGU_VERSION)
    const data = await favManager.loadFavoris({ dialogMode: 'silent' })
    return data?.num ?? 0
  }

  return {
    checkCguExpirées,
    setCguValidées
  }
})
